import { ErrorResponse } from '@src/interface/api/response.interface'
import { getVendorProducts } from '@src/lib/api/product/getVendorProducts'
import type { Product } from '@src/type/product'
import {
	UseInfiniteQueryResult,
	useInfiniteQuery,
	QueryFunctionContext,
	QueryClient,
	UseInfiniteQueryOptions,
} from '@tanstack/react-query'
import { AxiosError } from 'axios'
import { useEffect } from 'react'

type ParamTypes = {
	limit: number
	keyword?: string
	options?: UseInfiniteQueryOptions<
		Product[],
		AxiosError<ErrorResponse>,
		Product[],
		Product[],
		['getVendorProducts']
	>
}
const useGetVendorProductsQuery = ({
	limit,
	keyword,
	options,
}: ParamTypes): UseInfiniteQueryResult<Product[], AxiosError<ErrorResponse>> => {
	useEffect(() => {
		return function clear() {
			const queryClient = new QueryClient()
			queryClient.resetQueries(['getVendorProducts'], { exact: true }).catch(() => {})
		}
	}, [])
	return useInfiniteQuery(
		['getVendorProducts'],
		async ({ pageParam }: QueryFunctionContext<['getVendorProducts'], Product>) => {
			const lastProductNo = pageParam?.no
			const response = await getVendorProducts({
				lastPosNo: lastProductNo,
				limit,
				titleIlk: keyword,
			})
			const { products } = response.data
			return products
		},
		{
			enabled: false,
			cacheTime: 0,
			getNextPageParam: (products) => products.at(-1),
			...options,
		},
	)
}
export default useGetVendorProductsQuery
